import { GitCommit, ExternalLink, FileCode } from "lucide-react";

function renderDiffLine(line, i) {
  const t = line[0];
  let cls = "text-slate-600";
  if (t === "+") cls = "diff-add";
  else if (t === "-") cls = "diff-del";
  else if (line.startsWith("@@")) cls = "diff-hunk";
  return (
    <div key={i} className={`whitespace-pre ${cls} px-3`}>
      {line || " "}
    </div>
  );
}

export default function CodeDiff({ patches }) {
  if (!patches || patches.length === 0) {
    return (
      <section
        data-testid="code-diff"
        className="panel p-6 md:p-7 fade-up delay-2"
      >
        <div className="overline mb-2">Patch Diff</div>
        <p className="text-slate-500 text-sm">
          No public GitHub patch diff is referenced in NVD for this CVE. The AI
          analysis above is based on advisory text and the CVE description.
        </p>
      </section>
    );
  }

  return (
    <section
      data-testid="code-diff"
      className="panel p-6 md:p-7 fade-up delay-2"
    >
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="overline">Patch diff // before vs after</div>
          <h3 className="font-display text-xl text-slate-900 mt-1">
            What the fix actually does
          </h3>
        </div>
      </div>

      <div className="space-y-5">
        {patches.map((p, idx) => (
          <div key={idx} className="bg-slate-50 border border-slate-200 rounded-md overflow-hidden">
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 px-4 py-3 border-b border-slate-200 bg-slate-50">
              <GitCommit className="h-4 w-4 text-violet-700 shrink-0" />
              <span className="font-mono text-sm text-slate-900">{p.repo}</span>
              <span className="font-mono text-xs text-slate-500">
                {(p.sha || "").slice(0, 10)}
              </span>
              <span className="text-xs text-slate-600 truncate flex-1">
                {(p.message || "").split("\n")[0]}
              </span>
              {p.html_url && (
                <a
                  href={p.html_url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-slate-600 hover:text-violet-700"
                  data-testid={`diff-link-${idx}`}
                >
                  <ExternalLink className="h-4 w-4" />
                </a>
              )}
            </div>

            {(p.files || []).map((f, fi) => (
              <div key={fi} className="border-b border-slate-100 last:border-0">
                <div className="flex items-center gap-2 px-4 py-2 bg-slate-100">
                  <FileCode className="h-3.5 w-3.5 text-slate-500" />
                  <span className="font-mono text-xs text-slate-700">
                    {f.filename}
                  </span>
                  <span className="ml-auto font-mono text-[10px] text-slate-500">
                    <span className="text-emerald-700">+{f.additions}</span>{" "}
                    <span className="text-red-700">-{f.deletions}</span>
                  </span>
                </div>
                {f.patch && (
                  <pre className="text-xs font-mono py-2 overflow-x-auto">
                    {f.patch.split("\n").slice(0, 80).map(renderDiffLine)}
                  </pre>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
